import { getSession } from 'next-auth/react';
import SignUp from 'templates/SignUp';
import { toSafeCallbackUrl } from 'utils/safeCallbackUrl';

export default function Login() {
  return <SignUp />;
}

export async function getServerSideProps(context) {
  const session = await getSession(context);
  if (session) {
    return {
      redirect: {
        destination: toSafeCallbackUrl(context.query?.callbackUrl),
        permanent: false,
      },
    };
  }

  return {
    props: {
      session,
    },
  };
}
